import type { PracticalProject } from "../../data";

export const ecSite: PracticalProject = {
  id: "ec-site",
  num: 1,
  title: "実践プロジェクト① ECサイト開発 — Java + JSP + PostgreSQL でフルスタックスキルを身につける",
  description: "ショッピングカート・決済機能をフルスタックで実装",
  duration: "1〜2か月",
  techStack: ["Java", "JSP", "Tomcat", "PostgreSQL"],
  figmaUrl:
    "https://www.figma.com/design/5LLAPdI03tsb3z0ufTofP6/%E5%AE%9F%E8%B7%B5%E3%83%97%E3%83%AD%E3%82%B8%E3%82%A7%E3%82%AF%E3%83%88_%E8%AA%B2%E9%A1%8C%E3%80%90Luagate%E3%80%91?node-id=0-1",
  demoUrl: "https://prod-luagate-pj-ec-demo-v3bbmayaea-an.a.run.app",
  starterUrl: "https://prod-luagate-pj-ec-demo-starter-v3bbmayaea-an.a.run.app",
  repoUrl: "https://github.com/Luagate-com/luagate_pj_ec_site",
  starterRepoUrl: "https://github.com/Luagate-com/luagate_pj_ec_site/tree/starter",
  difficulty: "intermediate",
  phase: "Phase 3 後半",
  learningOutcomes: [
    "ヒアリング → 企画書 → 要件定義 → 設計 → 実装 の実務フローを 1 周経験できる",
    "Java + JSP + Servlet + PostgreSQL でフルスタック開発ができるようになる",
    "セッション管理・認証・トランザクション処理を実装できるようになる",
    "EC サイト相当の実装をポートフォリオに持てる",
  ],
  chapters: [
    { num: 1, title: "はじめに" },
    { num: 2, title: "ヒアリング" },
    { num: 3, title: "企画書" },
    { num: 4, title: "要件定義" },
    {
      num: 5,
      title: "基本設計",
      figmaFrames: [
        { title: "商品一覧 (FR-01)", nodeId: "1-102" },
        { title: "商品詳細 (FR-02)", nodeId: "1-168" },
        { title: "カート (FR-03)", nodeId: "1-211" },
        { title: "注文・レジ (FR-04)", nodeId: "1-263" },
        { title: "注文完了 (FR-04)", nodeId: "1-483" },
        { title: "ログイン (FR-06)", nodeId: "1-351" },
        { title: "新規登録 (FR-08)", nodeId: "1-388" },
        { title: "マイページ (FR-09)", nodeId: "1-433" },
      ],
    },
    { num: 6, title: "詳細設計" },
    { num: 7, title: "実装の進め方" },
    { num: 8, title: "7-1: 環境構築" },
    { num: 9, title: "7-2: DB 準備とプロジェクト雛形" },
    {
      num: 10,
      title: "7-3: 商品一覧・詳細",
      figmaFrames: [
        { title: "商品一覧 (FR-01)", nodeId: "1-102" },
        { title: "商品詳細 (FR-02)", nodeId: "1-168" },
      ],
    },
    {
      num: 11,
      title: "7-4: カート機能",
      figmaFrames: [{ title: "カート (FR-03)", nodeId: "1-211" }],
    },
    {
      num: 12,
      title: "7-5: 認証機能",
      figmaFrames: [
        { title: "ログイン (FR-06)", nodeId: "1-351" },
        { title: "新規登録 (FR-08)", nodeId: "1-388" },
      ],
    },
    {
      num: 13,
      title: "7-6: レジ・注文確定 (トランザクション)",
      figmaFrames: [
        { title: "注文・レジ (FR-04)", nodeId: "1-263" },
        { title: "在庫不足エラー (FR-04)", nodeId: "9-1681" },
        { title: "注文完了 (FR-04)", nodeId: "1-483" },
      ],
    },
    {
      num: 14,
      title: "7-7: マイページ",
      figmaFrames: [{ title: "マイページ (FR-09)", nodeId: "1-433" }],
    },
    { num: 15, title: "7-8: 仕上げ (CSS・エラー・セキュリティ)" },
    { num: 16, title: "実装 FAQ (詰まったとき用)" },
    { num: 17, title: "テスト・提出" },
    { num: 18, title: "用語ミニ辞書" },
  ],
};
